import * as React from 'react';
import { Dimensions, StyleSheet } from 'react-native';
import Svg, { RadialGradient, Rect, Stop } from 'react-native-svg';
import { View } from 'smoothie';

const BackgroundGradient = () => {
    const { width, height } = Dimensions.get('window');
    const gradientId = React.useId();

    return (
        <View style={[StyleSheet.absoluteFill]}>
            <Svg
                width={width}
                height={height}
                viewBox={`0 0 ${width} ${height}`}
            >
                <RadialGradient
                    id={gradientId}
                    cx="50%"
                    cy="50%"
                    rx="46.3%"
                    ry="46.3%"
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop offset="0" stopColor="#EDF8EC" stopOpacity="1" />
                    <Stop offset="1" stopColor="#FFFFFF" stopOpacity="1" />
                </RadialGradient>
                <Rect
                    x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    fill={`url(#${gradientId})`}
                />
            </Svg>
        </View>
    );
};

export default BackgroundGradient;
